<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-4">
        <div class="sticky-top">
        <b-navbar class="flex-column " v-b-scrollspy:scrollspy-nested="config">
          <b-navbar-brand>
            <img :src="require('../assets/images/wegovnow-logo-icon.png')"/>
          </b-navbar-brand>
          <b-nav pills vertical>
            <b-nav-item href="#main">What is WeGovNow OTM</b-nav-item>
            <b-nav-item href="https://api.ontomap.eu/" target="_blank">APIs Description</b-nav-item>
            <b-nav-item href="#installation">Installation Instructions </b-nav-item>
            <b-nav pills vertical>
              <b-nav-item class="ml-3 my-1" href="#git_repo">Project Source Code</b-nav-item>
              <b-nav-item class="ml-3 my-1" href="#parliament">Open Data Management</b-nav-item>
              <b-nav-item class="ml-3 my-1" href="#mongo">User Activity Logging</b-nav-item>
              <b-nav-item class="ml-3 my-1" href="#runApp">Run the application</b-nav-item>
            </b-nav>
            <b-dropdown-divider></b-dropdown-divider>
            <b-nav-item href="#licenses">Licenses</b-nav-item>
            <b-nav-item href="#privacy">Privacy Information</b-nav-item>
            <b-nav-item href="#about">About this guide</b-nav-item>
          </b-nav>
        </b-navbar>
        </div>
      </div>
      <div class="col-lg-9 col-md-8" >
        <div id="scrollspy-nested">
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h4 id="main">What is WeGovNow OnToMap and OTM Logger</h4>
            <p>The OnToMap Logger is a WeGovNow platform component which collects, aggregates and
              publishes data about user activities that are collected by the front-end applications of the
              platform; this data is sent to the logger by the front-end applications themselves.
              The Logger doesn’t have access to any personal data belonging to the users, and it uses only
              their numeric identifier (UWUM ID), which is used to associate the logged events to the users
              generating them through their actions (e.g., the editing of a geographic piece of data).<br/>
              Specifically, the OTM Logger provides the following functions:
            </p>
            <ul>
              <li><span class="font-italic">Centralised logging of user activities within the WeGovNow platform.</span>
                The
                OnToMap Logger is a
                centralised collector of the history of actions performed by WeGovNow users by interacting with
                the WeGovNow applications. The goal is that of achieving a unified perspective on user
                behaviour, e.g., to support cross-application personalisation. Within the WeGovNow platform,
                applications push their log data to a single component (the OnToMap Logger), which merges the
                information managing a unified history of user activities. In order to effectively support
                information retrieval, centralised logging has to be coupled with data integration. In fact, as
                applications can adopt different terminologies, the user activities they log might seem to refer
                to different types of information even when it is not the case. This leads to the second role of
                the Logger, described in the following.
              </li>
              <li><span class="font-italic">
                                Data integration across WeGovNow applications.</span> The Logger provides a unified view
                on the data
                shared in the WeGovNow platform, including the Open Data managed by OnToMap, in order to enable
                WeGovNow applications to retrieve information collected about geographical objects, initiatives,
                issues, and so forth to populate their maps. As applications can use diverse conceptual models
                for representing geographical information, heterogeneous data descriptions have to be
                reconciled. The OnToMap Logger addresses this issue by exploiting the semantic representation of
                geographical information provided by <a href="https://ontomap.eu/ontology/">OnToMap Ontology</a>, that
                is
                used as an interlingua among
                WeGovNow applications. The ontology formally represents the concepts in which the data shared
                among the WeGovNow applications can be classified: the data categories defined by an application
                can be mapped to the concepts of the ontology, at application integration time, to define the
                rules for translating the information provided by the application to the common ontology format.
              </li>
            </ul>
          </div>
          <!--Installation Instruction-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h4 id="installation"><strong>Installation Instructions</strong></h4>
            <p>
              This page presents the installation instructions of OnToMap and OTM
              Logger within the WeGovNow platform.
              The page is structured in the following sections:
            </p>
            <ol>
              <li><strong>Project code</strong>: this section reports the link to the GitLab open source
                repository of the application project.
              </li>
              <li><strong>Open Data Management</strong>: OnToMap makes it possible to manage Open Data
                (typically provided by the Municipalities

                of the platform instances). This section provides the following
                information items:
                <ul>
                  <li>link that can be used to download the Open Data provided by

                    the cities of London (Southwark), San Don&agrave; di Piave and Torino,
                    represented as Linked Data (RDF format).
                  </li>
                  <li>link to download the Parliament Triple Store that handles the
                    Linked Data and the instructions to install Parliament and load

                    Open Data in the Triple Store.
                  </li>
                </ul>

              </li>
              <li><strong>User Activity Logging</strong>: the OTM Logger exploits the MongoDB no-SQL
                database to store user activity data. This section provides

                the following information items:

                <ul>
                  <li>link to download MongoDB and instructions to run it.</li>
                  <li>link to download an empty MongoDB database that contains the basic
                    collections of information needed to use MongoDB within the WeGovNow
                    platform.
                  </li>
                </ul>
              </li>
              <li><strong>Run the application</strong>: this section provides instructions to deploy
                OnToMap and OTM Logger.
              </li>
            </ol>
          </div>
          <!--Project Source Code-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h5 id="git_repo"><strong>Project Source Code</strong></h5>
            <p>The project code can be downloaded from <a href="https://gitlab.com/ontomap/ontomap-wegovnow">GitLab
              Repository</a>.
            </p>
          </div>
          <!--Open Data Management-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h5 id="parliament"><strong>Open Data Management</strong></h5>
            <ul>
              <li> The Open Data provided for the WeGovNow Project by the cities of London Southwark, San Don&agrave;
                di Piave and Torino
                can be downloaded from <a href="data/opendata_rdf.zip">Open Data Download</a>.
              </li>
              <li>The Parliament Triple Store software can be downloaded from
                <a href="http://semwebcentral.org/frs/?group_id=159" target="_blank">SemWebCentral</a> (choose
                the
                QuickStart version). Currently, the OnToMap and OTM Logger run version 2.7.10 of Parliament. The
                downloaded directory contains a guide (ParliamentUserGuide.pdf) and the
                StartParliament.bat/StartParliament.sh shell files to start it.
              </li>
              <li>Load the Open Linked Data (RDF Triples) in Parliament:
                <ol>
                  <li>Go to "<a href="http://localhost:8089/parliament/"
                                target="_blank">http://localhost:8089/parliament/</a>"
                    (Default PORT is 8089, but it can be changed in the StartParliament file).
                  </li>
                  <li>Click on link "Insert Data".</li>
                  <li>Import Repository Selection: select the Open Data to be loaded and press "Import
                    Repository".
                  </li>
                  <li>When the Linked Data has been loaded it must be indexed. For this purpose, go to Indexed
                    Page and select "Create All".
                  </li>
                  <li>At this point Parliament is ready to be queried from applications.</li>
                </ol>
                <br/>
                <p><strong>Notice</strong>: every time Parliament is started the data loading
                  procedure should be
                  executed from the beginning! In order to avoid this problem, before closing Parliament,
                  you should execute the "exit" command in the window of the StartParliament shell. See
                  figure below.</p>
                <img :src="require('../assets/images/exitParliament.jpg')" class="w-75"/>
              </li>
            </ul>
          </div>
          <!--User Activity Logging-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h5 id="mongo"><strong>User Activity Logging</strong></h5>
            <p>Logged activity data is stored in a no-SQL
              database.
              The current version of OnToMap and OTM Logger uses version 4.0 of MongoDB as DBMS.</p>
            <p>
              You can download MongoDB and install
              it from the <a
                href="https://www.mongodb.com/mongodb-4.0"
                target="_blank">Mongo Web site</a>. </p>
            <p>
              After having installed MongoDB you can start it using the following
              command line:
            </p>
            <p class="text-center">
              <kbd>"mongodb_4_path" --dbpath "DIR" --replSet "rs0"</kbd></p>
            where:
            <ul>
              <li>mongodb_4_path is the installation path of MongoDB.</li>
              <li>DIR is the location of the database.</li>
              <li>rs0 indicates that you run MongoDB using transactions (Replica Set Mode).
              </li>
            </ul>
            <p class="mt-2">
              The database used by OTM Logger is composed of the following 8 collections:
            </p>
            <ol>
              <li><strong>access_tokens</strong>: it contains the tokens used by the <a
                  href="https://ontomap.eu/#api-Token_APIs"
                  target="_blank">Token API</a>. Every token is associated to a single
                application and they are used to bypass certificate validation in the cases
                in which certificates cannot be used: for example a GET request made by a client with Javascript
                (AJAX).
              </li>
              <li><strong>events</strong>: this is the main collection. Here the events pushed to the OTM Logger
                by using the <a href="https://api.ontomap.eu/#api-Logger_APIs"
                                target="_blank">Events API </a> are stored.
              </li>
              <li><strong>features</strong>:every time a user activity event is stored, the geographic item that
                is the object of the user action is inserted (or updated) in this collection. This collection is
                used as support to some methods used by Events API, but you can directly interface with this
                list using the <a
                    href="https://api.ontomap.eu/#api-Instances_APIs-GetConceptInstances" target="_blank">Instances
                  API</a>. The inserted geographic items are represented as features in <a
                    href="http://geojson.org/" target="_blank">GeoJson</a> format, extended with some
                attributes added to indicate the WeGovNow platform instance to which they belong and the name of
                the application that pushed the event to the OTM Logger.
              </li>
              <li><strong>idempotency</strong>: This collection includes keys to prevent an entry request being
                made multiple times. The idempotency-key must be entered in the POST request’s header. Idempotency-keys
                are automatically deleted by the DBMS after 24 hours.
              </li>
              <li><strong>mapping_rules</strong>:This collection contains the mappings between the concepts (with
                attributes) defined in the domain representation adopted by a WeGovNow front-end application and
                the concepts (with attributes) defined in the OnToMap Ontology. These mappings are used at
                runtime in order to translate the information events pushed to the OTM Logger to the interlingua
                provided by the OnToMap Ontology. Every item of this collection refers to a specific WeGovNow
                application and platform instance. See <a
                    href="https://ontomap.eu/#api-Mapping_APIs" target="_blank">Mapping APIs</a>.
              </li>
              <li><strong>subscriptions</strong>: This collection contains the list of subscriptions used by the
                <a
                    href="https://api.ontomap.eu/#api-Subscriptions_APIs" target="_blank">Subscriptions
                  APIs</a>. A subscription must be made by a WeGovNow application indicating the type of event
                to which it wants to subscribe: in this way when an event of that type is pushed to the OTM
                Logger, the Logger will send a notification to the application.
              </li>
            </ol>
            <p>An empty template of the databased to be used by the OTM Logger (including the 8 collections with
              respective indexes) can be downloaded from <a href="data/empty_db_backup.archive">Mongo
                Empty Backup</a>. The template can be loaded in MongoDB using following shell code:<br/>
              <kbd>mongorestore -v --host localhost:PORT --username DB_USERNAME --password DB_PASSWORD
                --authenticationDatabase admin --archive=RESTORE_FILEPATH --objcheck -drop</kbd>
            </p>
          </div>
          <!--Run the application-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h5 id="runApp"><strong>Run the application</strong></h5>
            <p>The IDE we suggest for deploying OnToMap and OTM Logger is <a href="https://www.jetbrains.com/"
                                                                             target="_blank">IntelliJ IDEA
              Ultimate</a> because it supports the <a href="https://www.playframework.com/"
                                                      target="_blank">Play Framework</a>.
              Before pulling the OnToMap project from GitLab you must install the <a
                  href="https://confluence.jetbrains.com/display/SCA/ScalaPluginforIntelliJIDEA"
                  target="_blank">Scala plugin</a> to use the framework.
            </p>
            <p>
              Moreover, you have to configure the the Run/Debug facets of the IntelliJ project as follows:
            </p>
            <ol>
              <li><img :src="require('../assets/images/step_1.jpg')"/></li>
              <li><img class="w-75" :src="require('../assets/images/step_2.jpg')"/></li>
            </ol>
            Before running OnToMap and OTM Logger you have to start MongoDB and Parliament servers.
          </div>


          <!--LICENSES-->
          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h4 id="licenses"><strong>License</strong></h4>
            <h6 class="mt-4"><strong>Subcomponents shipped With Component</strong></h6>
            <table class="table ">
              <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Publisher</th>
                <th scope="col">License</th>
                <th scope="col">URL</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row">Play Framework</th>
                <td>Java Server</td>
                <td>Lightbend Inc.</td>
                <td>Apache 2.0</td>
                <td><a href="https://www.playframework.com/">https://www.playframework.com/</a></td>
              </tr>
              <tr>
                <th scope="row">Esri Geometry API</th>
                <td>Java Library</td>
                <td>Esri</td>
                <td>Apache 2.0</td>
                <td><a href="https://github.com/Esri/geometry-api-java">https://github.com/Esri/geometry-api-java</a>
                </td>
              </tr>
              <tr>
                <th scope="row">Json Schema Validator</th>
                <td>Java Library</td>
                <td>Francis Galiegue</td>
                <td>LGPLv3</td>
                <td><a href="https://github.com/fge/json-schema-formats">https://github.com/fge/json-schema-formats</a>
                </td>
              </tr>
              <tr>
                <th scope="row">Http Request</th>
                <td>Java Library</td>
                <td>Kevin Sawicki</td>
                <td>MIT License</td>
                <td><a
                    href="https://github.com/kevinsawicki/http-request">https://github.com/kevinsawicki/http-request</a>
                </td>
              </tr>
              <tr>
                <th scope="row">JSoup</th>
                <td>Java Library</td>
                <td>Jonathan Hedley</td>
                <td>MIT License</td>
                <td><a href="https://github.com/jhy/jsoup">https://github.com/jhy/jsoup</a></td>
              </tr>
              <tr>
                <th scope="row">Jena</th>
                <td>Java Library</td>
                <td>Apache</td>
                <td>Apache 2.0</td>
                <td><a href="https://jena.apache.org/">https://jena.apache.org/</a></td>
              </tr>

              </tbody>
            </table>
            <h6 class="mt-4"><strong>Run-Time Dependencies</strong></h6>
            <table class="table">
              <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Publisher</th>
                <th scope="col">License</th>
                <th scope="col">URL</th>
              </tr>
              </thead>
              <tbody>

              <tr>
                <th scope="row">Parliament</th>
                <td>Triplestore</td>
                <td>SemWebCentral</td>
                <td>BSD License</td>
                <td><a href="http://semwebcentral.org/">http://semwebcentral.org/</a></td>
              </tr>
              <tr>
                <th scope="row">Mongo DB</th>
                <td>Database</td>
                <td>MongoDB Inc</td>
                <td>AGPL v3</td>
                <td><a href="https://www.mongodb.com/">https://www.mongodb.com/</a></td>
              </tr>

              </tbody>
            </table>

            <h6 class="mt-4"><strong>Built-Time Dependencies</strong></h6>
            <table class="table">
              <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Publisher</th>
                <th scope="col">License</th>
                <th scope="col">URL</th>
              </tr>
              </thead>
              <tbody>

              <tr>
                <th scope="row">apiDoc</th>
                <td>Web API Generator</td>
                <td>Peter Rottmann</td>
                <td>MIT License</td>
                <td><a href="http://apidocjs.com">http://apidocjs.com</a></td>
              </tr>
              </tbody>
            </table>
          </div>


          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h4 id="privacy"><strong>OnToMap Logger description and setup of stored data</strong></h4>
            <p>The OnToMap Logger is a WeGovNow platform component which collects, aggregates and
              publishes data about user activities that are collected by the front-end applications of the
              platform; this data is sent to the logger by the front-end applications themselves.</p>
            <p>
              The OnToMap Logger manages exclusively public, geographic data; it doesn’t verify neither the
              quality nor the appropriateness of the data sent to it, since this task is demanded to the frontend
              applications originally collecting the data. All data published to the Logger by a front-end
              application is available to all the applications within an instance of the WeGovNow platform.</p>
            <p>
              The Logger doesn’t have access to any personal data belonging to the users, and it uses only
              their numeric identifier (UWUM ID), which is used to associate the logged events to the users
              generating them through their actions (e.g., the editing of a geographic piece of data).</p>
            <p>

              In the following we list the information collected by the logger, divided by category:</p>

            <h5><strong>Category A (master data)</strong></h5>
            <p>Master data is used to univocally identify a user account.</p>
            <p>The only data pertaining to this category stored by the logger is the numeric user identifier, as
              provided by the WeGovNow front-end applications requesting the storage of the events.</p>
            <ul>
              <li>Numeric User Identifier (UWUM ID)</li>
            </ul>

            <h5><strong>Category B (identification data)</strong></h5>
            <p>Identification data is used to associate a user account with an accredited person.</p>
            <p>The OnToMap Logger does not store any data pertaining to this category.</p>

            <h5><strong>Category C (profile data)</strong></h5>
            <p>Profile data is voluntary information provided by the participant about themselves and may be
              changed or deleted at any time by the participant.</p>
            <p>The OnToMap Logger does not store any data pertaining to this category.</p>

            <h5><strong>Category D (content data)</strong></h5>
            <p>Content data is associated to each event representing a user action, and provides a description of
              the user action itself.</p>
            <p>The Logger does not acquire any piece of content data itself: it only stores the data items
              belonging to the events pushed to it by the front-end applications.</p>
            <p>The mandatory content data pieces required for all events are:</p>
            <ul>
              <li>Type of the user action</li>
              <li>Timestamp of the user action</li>
            </ul>

            <h5><strong>Category E (usage data)</strong></h5>
            <p>Usage data refers to the actions taken by the users in the WeGovNow front-end applications.</p>
            <p>The Logger does not acquire any piece of content data itself: it only stores the data items
              belonging to the events pushed to it by the front-end applications.</p>

            <h5><strong>Category F (login and settings data)</strong></h5>
            <p>Login and settings data is only intended for use by a particular user and is required for operation.</p>
            <p>The OnToMap Logger does not store any data pertaining to this category.</p>

            <h5><strong>Category G (web server log data)</strong></h5>
            <p>Web server log data is generated whenever the Logger is used, either to store or to retrieve
              events.</p>
            <ul>
              <li>Source of request (IP address)</li>
              <li>Timestamp of request</li>
              <li>Requested URL</li>
              <li>HTTP Referer</li>
              <li>HTTP User Agent</li>
              <li>Size of response</li>
              <li>Status code of response</li>
            </ul>
            <p>Users will have access to data pertaining to categories A, D, and E, through the front-end
              applications. Data pertaining to category G is not available to any user or WeGovNow front-end
              application.</p>


            <h5><strong>Data deletion for the OnToMap Logger</strong></h5>
            <p>Upon request, it is possible to delete the following types of data:</p>
            <ul>
              <li>Individual data items (single logged events)</li>
              <li>Data items containing the ID of a specific user (events concerning that user)</li>
              <li>Data originating from a specific application (events pushed to the logger by that
                application)
              </li>
            </ul>
          </div>

          <div class="border rounded  bg-light shadow mb-3 p-3">
            <h4 id="about">About this guide</h4>
            <p>This guide briefly presents the WeGovNow project outcomes by the OnToMap team of the Computer Science
              Department.

              The guide is targeted to system administrators who aim to install the OnToMap backend of the
              WeGovNow platform (including OTM Logger for centralized logging of user activities within an
              instance of the WreGovNow platform).

              The guide contains links to the software components and libraries that have to be downloaded and
              installed, installation and deployment instructions, source code of OnTomap and OTM Logger, and
              public Open Data available in Linked Data format.</p>

            <h4>Contact</h4>
            <p><strong>Computer Science Department</strong><br/>
              <strong>University of Torino</strong><br/>
              <img :src="require('../assets/images/address_email.png')">
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center mt-4">
      <div class="col-md-4 rounded text-center p-4">
        This project has received funding from the European Union\s Horizon 2020 research and innovation
        programme under grant agreement No <a href="https://cordis.europa.eu/project/rcn/200261/factsheet/en"
                                              target="_blank">693514</a><br>
        <img  :src="require('../assets/images/eu.png')" alt="EU emblem">
      </div>
      <div class="offset-md-1 col-md-4 text-center p-4">
        Computer Science Department<br/> University of Torino <br/> <a
          href="http://www.dipinformatica.unito.it/" target="_blank">
        <img style="height: 100px" :src="require('../assets/images/logo_dipartimento.jpg')"/></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WGN",
  data () {
    return {
      config: {
        element: 'body',
        offset: 10,
        method: 'auto',
        throttle: 100
      }
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style scoped>

</style>
